import { Link } from "react-router-dom";
import type { RecommendItem } from "@/types/content";

export default function RecommendCard({ item }: { item: RecommendItem }) {
  return (
    <Link
      to={`/detail/recommend/${item.id}`}
      className="group block rounded-lg border border-background-200 bg-background-50 overflow-hidden hover:border-primary-300 transition-colors cursor-pointer"
    >
      <div className="relative w-full aspect-[3/4] overflow-hidden">
        <img
          src={item.cover}
          alt={item.title}
          title={`${item.title} - 香蕉动漫`}
          className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
        />
        <span className="absolute top-2 right-2 inline-flex items-center gap-1 rounded-md bg-black/55 px-2 py-0.5 text-xs font-bold text-primary-400">
          <i className="ri-star-fill w-3.5 h-3.5 flex items-center justify-center"></i>
          {item.score}
        </span>
        <span className="absolute bottom-2 left-2 rounded-md bg-primary-500/95 px-1.5 py-0.5 text-[10px] font-bold text-foreground-950">
          {item.status}
        </span>
      </div>
      <div className="p-3">
        <h3 className="font-bold text-sm text-foreground-950 line-clamp-1 group-hover:text-accent-600 transition-colors">
          {item.title}
        </h3>
        <p className="mt-1 text-xs text-foreground-500 line-clamp-2">{item.summary}</p>
        <div className="mt-2 flex flex-wrap gap-1">
          {item.genres.slice(0, 3).map((g) => (
            <span
              key={g}
              className="rounded-full bg-secondary-100 px-2 py-0.5 text-[10px] text-secondary-900"
            >
              {g}
            </span>
          ))}
        </div>
      </div>
    </Link>
  );
}